import React from "react";
import { Modal, Form, Input, message } from "antd";
import PropTypes from "prop-types";
import userApi from "@/api/module/user";
import { showDanger, showSuccess } from "@/utils";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const ChangePasswordModal = ({ visible, onCancel, onOk }) => {
    const [form] = Form.useForm();
    const history = useHistory();

    const handleOk = () => {
        form.validateFields()
            .then((values) => {
                // 修改后的接口调用
                userApi.changePassword(
                    values.oldPassword,
                    values.newPassword,
                    (res) => {
                        if (res.data.code === 0) {
                            showSuccess("密码修改成功，请重新登录");
                            history.push("/login");
                        } else {
                            showDanger(res.data.msg || "密码修改失败");
                        }
                    },
                    (err) => {
                        showDanger(err.msg || "密码修改失败");
                    }
                );
                onOk(); // This will typically close the modal and reset the form
            })
            .catch((info) => {
                console.log("Validate Failed:", info);
            });
    };

    return (
        <Modal
            title="修改密码"
            open={visible}
            onOk={handleOk}
            onCancel={onCancel}
            okText="确定"
            cancelText="取消"
            destroyOnHidden
        >
            <Form
                form={form}
                layout="vertical"
                name="change_password_form"
                preserve={false}
            >
                <Form.Item
                    name="oldPassword"
                    label="旧密码"
                    rules={[{ required: true, message: "请输入您的旧密码!" }]}
                    style={{ marginBottom: 10 }}
                >
                    <Input.Password
                        placeholder="请输入您的旧密码"
                        style={{ height: 40 }}
                    />
                </Form.Item>
                <Form.Item
                    name="newPassword"
                    label="新密码"
                    rules={[{ required: true, message: "请输入您的新密码!" }]}
                    hasFeedback
                    style={{ marginBottom: 10 }}
                >
                    <Input.Password
                        placeholder="请输入您的新密码"
                        style={{ height: 40 }}
                    />
                </Form.Item>
                <Form.Item
                    name="confirmPassword"
                    label="确认新密码"
                    dependencies={["newPassword"]}
                    hasFeedback
                    style={{ marginBottom: 10 }}
                    rules={[
                        { required: true, message: "请确认您的新密码!" },
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                                if (
                                    !value ||
                                    getFieldValue("newPassword") === value
                                ) {
                                    return Promise.resolve();
                                }
                                return Promise.reject(
                                    new Error("两次输入的密码不匹配!")
                                );
                            },
                        }),
                    ]}
                >
                    <Input.Password
                        placeholder="请确认您的新密码"
                        style={{ height: 40 }}
                    />
                </Form.Item>
            </Form>
        </Modal>
    );
};

ChangePasswordModal.propTypes = {
    visible: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    onOk: PropTypes.func.isRequired,
};

export default ChangePasswordModal;
